import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CouponsFilters } from '../../../commons/models/coupons';

@Component({
  selector: 'app-coupons-filters',
  templateUrl: './coupons-filters.component.html',
  styleUrls: ['./coupons-filters.component.scss']
})
export class CouponsFiltersComponent {
  @Output()
  onFilter: EventEmitter<CouponsFilters> = new EventEmitter();

  private _defaultFilters: CouponsFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getPayment());
  }

  private _getPayment(): CouponsFilters {
    let filters: CouponsFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): CouponsFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: CouponsFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
